module.exports = __webpack_public_path__ + "static/media/current-status-record-complete.3426f42e.jpg";